import { useTranslation } from "react-i18next";
import BannerSection from "../../components/AboutPages/Banner";
import FilterSection from "../../components/TutorPages/FilterSection";
import TutorsResult from "../../components/TutorPages/TutorsResult";
import bannerImage from "../../images/asserts/Website-Assets/Find a Tutor/Hero_image.webp";
import { useEffect } from "react";

const Tutor = () => {
   useEffect(() => {
   
      const lang = localStorage.getItem("i18nextLng");
      if (!lang || lang === "en-US") {
        localStorage.setItem("i18nextLng", "en");
        window.location.reload();
      }
    }, []); 
  const { t }: { t: (key: string) => string } = useTranslation();

  return (
    <main>
      <BannerSection title={t('HireTutor')} image={bannerImage} />
      <FilterSection />
      <TutorsResult />
    </main>
  );
};

export default Tutor;
